export default "__VITE_ASSET__BlT6H27N__"